import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "planService",
    serviceName: "shared",
    query: gql`
      query planService(
        $ids: [String]
        $plan_ids: [String]
        $unit_ids: [String]
        $lab_ids: [String]
        $doctor_ids: [String]
        $servants: [String] # doctor,lab,unit,self
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        planService(
          ids: $ids
          plan_ids: $plan_ids
          unit_ids: $unit_ids
          lab_ids: $lab_ids
          doctor_ids: $doctor_ids
          servants: $servants
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            plan {
              id
            }
            unit {
              id
            }
            lab {
              id
            }
            doctor {
              id
            }
            servant
            details
          }
          total
          last_page
        }
      }
    `,
  },
};

export default schema;
